const planNames = {
  risqover_plus: 'RisqoverPro'
}

const featureIds = {
  createTemplate: 'createTemplate',
  createTeam: 'createTeam'
}

const criteria = [
  {
    id: 'isPlusUser',
    check: function (location) {
      return location.billing.subscriptions[0].product.toLowerCase() === planNames.risqover_plus.toLowerCase()
    }
  }
]

const features = [
  {
    id: featureIds.createTemplate,
    criteria: [{isPlusUser: true}]
  },
  {
    id: featureIds.createTeam,
    criteria: [{isPlusUser: true}]
  }
]

module.exports = {
  criteria: criteria,
  features: features,
  featureIds: featureIds
}



// WEBPACK FOOTER //
// ./src/services/features/config.js